<template>
	<CardComponent :bordered="true" padding="md">
		<div class="space-y-6">
			<div class="relative">
				<div
					v-for="(step, index) in trackSteps"
					:key="index"
					class="flex gap-4 pb-8 last:pb-0"
				>
					<div class="flex flex-col items-center">
						<div
							class="w-10 h-10 rounded-full flex items-center justify-center"
							:class="
								step.completed
									? 'bg-primary text-white'
									: 'bg-gray-200 text-gray-500'
							"
						>
							<i :class="step.icon"></i>
						</div>
						<div
							v-if="index < trackSteps.length - 1"
							class="w-0.5 flex-1 mt-2 h-16"
							:class="
								step.completed ? 'bg-primary' : 'bg-gray-200'
							"
						></div>
					</div>
					<div class="flex-1 pt-2">
						<h4 class="font-semibold text-text-primary">
							{{ step.title }}
						</h4>
						<p class="text-sm text-text-secondary mt-1">
							{{ step.description }}
						</p>
						<p class="text-xs text-text-secondary mt-2">
							{{ step.date }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</CardComponent>
</template>

<script>
import CardComponent from '../Card.vue';

export default {
	name: 'TrackTab',
	components: {
		CardComponent,
	},
	data() {
		return {
			trackSteps: [
				{
					icon: 'fa fa-check',
					title: 'Claim Submitted',
					description:
						'Your claim has been received and is being processed',
					date: 'Jan 10, 2026',
					completed: true,
				},
				{
					icon: 'fa fa-file-alt',
					title: 'Under Review',
					description: 'Our team is reviewing your claim details',
					date: 'Jan 11, 2026',
					completed: true,
				},
				{
					icon: 'fa fa-search',
					title: 'Assessment',
					description: 'Claim is being assessed by our adjusters',
					date: 'In Progress',
					completed: false,
				},
				{
					icon: 'fa fa-check-circle',
					title: 'Completed',
					description: 'Claim processed and payment issued',
					date: 'Pending',
					completed: false,
				},
			],
		};
	},
};
</script>

<style scoped></style>
